import {downloadFile} from '@domain/file-download'
import {ApiClient} from '@hconnect/apiclient'
import {AppName} from '@hconnect/common/hproduce'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import moment from 'moment-timezone'
import {useTranslation} from 'react-i18next'

import {TasksApiPath, FEATURE_NAMESPACE} from '../../consts'
import {TaskFilterDto} from '../../types'

const APP_NAME: AppName = 'HProduce'
const DATE_FORMAT = 'YYYY-MM-DD'

export const useExportCostLeadership = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation<Blob, AxiosError, TaskFilterDto | undefined>({
    mutationFn: async (filters) => {
      const response = await ApiClient.axiosInstance.post<Blob>(
        `${TasksApiPath.TASKS}/export-pom-cost-leadership`,
        filters,
        {
          responseType: 'blob'
        }
      )
      return response.data
    },
    onError: () => {
      spawnErrorToast(t('pomAction.message.costLeadershipExportFailed'))
    },
    onSuccess: (data) => {
      downloadFile(data, `${moment().format(DATE_FORMAT)}_${APP_NAME}_cost-leadership.xlsx`)
    }
  })
}
